const telCodes = [
  {
    value: '58',
    country: 'Venezuela',
    name: '58 - Venezuela',
  },
  {
    value: '54',
    country: 'Argentina',
    name: '54 - Argentina',
  },
  {
    value: '56',
    country: 'Chile',
    name: '56 - Chile',
  },
  {
    value: '593',
    country: 'Ecuador',
    name: '593 - Ecuador',
  },
  {
    value: '598',
    country: 'Uruguay',
    name: '598 - Uruguay',
  },
  {
    value: '1',
    country: 'Estados Unidos',
    name: '1 - Estados Unidos',
  },
];

const especialidades = [
  'Alergología',
  'Algología',
  'Análisis clínico',
  'Anatomía patológica',
  'Anestesiología',
  'Angiología',
  'Auditoría médica',
  'Bioquímica clínica',
  'Cardiología',
  'Cirugía bariátrica',
  'Cirugía cardíaca',
  'Cirugía craneofacial',
  'Cirugía general',
  'Cirugía oral y maxilofacial',
  'Cirugía oncológica',
  'Cirugía ortopédica',
  'Cirugía pediátrica',
  'Cirugía plástica',
  'Cirugía torácica',
  'Cirugía vascular',
  'Clínica Foniatría',
  'Coloproctología',
  'Dermatología',
  'Embriología',
  'Endocrinología',
  'Epidemiología',
  'Estomatología',
  'Farmacología',
  'Farmacología Clínica',
  'Gastroenterología',
  'Genética',
  'Genética médica',
  'Ginecología',
  'Ginecología y obstetricia',
  'Geriatría',
  'Hematología',
  'Hepatología',
  'Infectología',
  'Inmunología',
  'Medicina aeroespacial',
  'Medicina de emergencia',
  'Medicina del deporte',
  'Medicina estética',
  'Medicina familiar y comunitaria',
  'Medicina física y rehabilitación',
  'Medicina forense',
  'Medicina general',
  'Medicina intensiva',
  'Medicina interna',
  'Medicina nuclear',
  'Medicina paliativa',
  'Medicina preventiva y salud pública',
  'Medicina del trabajo',
  'Microbiología y parasitología',
  'Nefrología',
  'Neumología',
  'Neurocirugía',
  'Neurofisiología clínica',
  'Neurología',
  'Nutriología',
  'Oftalmología',
  'Odontología',
  'Oncología médica',
  'Oncología radioterápica',
  'Otorrinolaringología',
  'Pediatría',
  'Psiquiatría',
  'Radiología',
  'Reumatología',
  'Salud pública',
  'Toxicología',
  'Traumatología',
  'Traumatología y Ortopedia',
  'Urología',
  'Otra',
];


export {
  especialidades,
  telCodes,
};
